var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.307 19.7606C25.6945 20.3585 25.3445 21.2189 25.432 22.1377C25.5633 23.7127 27.007 24.8647 28.582 24.8647H31.3529V26.6001C31.3529 29.6189 28.8883 32.0835 25.8695 32.0835H9.12786C6.10911 32.0835 3.64453 29.6189 3.64453 26.6001V16.7856C3.64453 13.7668 6.10911 11.3022 9.12786 11.3022H25.8695C28.8883 11.3022 31.3529 13.7668 31.3529 16.7856V18.8856H28.407C27.5904 18.8856 26.8466 19.2064 26.307 19.7606Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64453 18.0979V11.4334C3.64453 9.69798 4.70911 8.15208 6.32786 7.53958L17.907 3.16458C19.7154 2.47916 21.6549 3.82087 21.6549 5.76046V11.3021",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8979 20.3732V23.3774C32.8979 24.1795 32.2563 24.8357 31.4396 24.8649H28.5813C27.0063 24.8649 25.5625 23.7128 25.4313 22.1378C25.3438 21.219 25.6938 20.3586 26.3063 19.7607C26.8459 19.2065 27.5896 18.8857 28.4063 18.8857H31.4396C32.2563 18.9149 32.8979 19.5711 32.8979 20.3732Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.207 17.5H20.4154",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWallet);
export default __webpack_public_path__ + "static/media/Empty-wallet.c8735790b44094502ddc1ee6c49244df.svg";
export { ForwardRef as ReactComponent };